import React from "react";
import { KuikaNestedBadge } from "../../../../ui-kit/kuika-nested-badge";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

export const NestedBadgeStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Nested Badge"
      componentName="KuikaNestedBadge"
      sourcePath="ui-kit/kuika-nested-badge"
      description="Group badge that contains child chips. Used for tagged filter groups — close removes the whole group."
    >
      <SpecRow label="Default" caption="purple group with blue children">
        <KuikaNestedBadge groupLabel="Roles">{["Admin", "Editor", "Viewer"]}</KuikaNestedBadge>
      </SpecRow>
      <SpecRow label="Color combinations" caption="groupColor × childColor">
        <KuikaNestedBadge groupLabel="Tags" groupColor="orange" childColor="yellow">
          {["urgent", "design"]}
        </KuikaNestedBadge>
        <KuikaNestedBadge groupLabel="Status" groupColor="green" childColor="green">
          {["live"]}
        </KuikaNestedBadge>
        <KuikaNestedBadge groupLabel="Errors" groupColor="red" childColor="red">
          {["E_404", "E_500"]}
        </KuikaNestedBadge>
      </SpecRow>
      <SpecRow label="Single child">
        <KuikaNestedBadge groupLabel="Region" groupColor="grey" childColor="blue">
          {["EU-West"]}
        </KuikaNestedBadge>
      </SpecRow>
      <SpecRow label="Hide child close buttons" caption="showChildClose=false — group can still be removed">
        <KuikaNestedBadge groupLabel="Locked group" groupColor="purple" childColor="purple" showChildClose={false}>
          {["Member A", "Member B"]}
        </KuikaNestedBadge>
      </SpecRow>
    </ShowcaseFrame>
  );
};
